import React, {useEffect, useState} from "react";
import type { ContextProps } from '../../../../types';
import {PageTitle} from "../../../../Components/Landmarks";
import {ManufacturerView} from "./ManufacturerView";
import {locations} from "../../../../Utilities/Location";
import {createListFromArrayOfObjects} from "../../../../Utilities/Types/listUtilities";
import {emptyGuid} from "../../../../Utilities/commonUtilities";
import {SelectField} from "../../../../Components/Inputs";
import {loanLibraryCatalogApi} from "./loanLibraryCatalogApi";
import {emptyManufacturerModel} from "./manufacturerFactory";

export const ManufacturerContainer = ({
                                           handleApiCall,
                                           loanLibraryManufacturerId,
                                           redirect,
                                       }: ContextProps) => {

    const [manufacturer, setManufacturer] = useState<Record<string, unknown>>();
    const [manufacturers, setManufacturers] = useState<Record<string, unknown>[]>();
    const manufacturerList = createListFromArrayOfObjects(manufacturers, "manufacturerId", "name");

    const handleChangeManufacturer = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const path = locations.LOAN_LIBRARY_MANUFACTURER.getLink([event.target.value]).to;
        redirect(path);
    }

    const handleReturn = () => redirect(locations.LOAN_LIBRARY_CATALOG.getLink().to);

    const handleSaveManufacturer = async (manufacturerFromForm: Record<string, unknown>) => {
        const manufacturerToSave = {
            ...manufacturerFromForm,
            manufacturerId: manufacturer?.manufacturerId
        };
        return handleApiCall(() => loanLibraryCatalogApi.saveManufacturer(manufacturerToSave),
            async () => {
                await handleApiCall(() => loanLibraryCatalogApi.getManufacturers(), (results: Record<string, unknown>[]) => setManufacturers(results));
                handleReturn();
            });
    };

    useEffect(() => {
        const getManufacturers = () => {
            handleApiCall(() => loanLibraryCatalogApi.getManufacturers(), (results: Record<string, unknown>[]) => setManufacturers(results));
        }

        const getManufacturer = () => {
            const found = manufacturers?.find((v: Record<string, unknown>) => v.manufacturerId === loanLibraryManufacturerId);
            if (found) {
                setManufacturer({ ...found });
            } else {
                setManufacturer({ ...emptyManufacturerModel });
            }
        }

        if (!manufacturers)
            getManufacturers();
        else if (loanLibraryManufacturerId)
            getManufacturer();

    }, [manufacturers, loanLibraryManufacturerId]);

    if (!manufacturer) return <></>;

    return <>
        <PageTitle h1={`Manage Manufacturers`}/>
        <SelectField
            defaultOption={"-- Create New Manufacturer --"}
            defaultOptionValue={emptyGuid}
            label={"Select Manufacturer to Manage"}
            name={'ManufacturerList'}
            onChange={handleChangeManufacturer}
            options={manufacturerList}
            value={loanLibraryManufacturerId}
        />
        <ManufacturerView
            handleReturn={handleReturn}
            handleSaveManufacturer={handleSaveManufacturer}
            manufacturer={manufacturer}
        />
    </>;
};

